import { render, staticRenderFns } from "./WebsiteOwner.vue?vue&type=template&id=510d08b6&lang=pug&"
import script from "./WebsiteOwner.vue?vue&type=script&lang=js&"
export * from "./WebsiteOwner.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteOwner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports